import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button, TextField, FormLabel } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
import InfoTooltip from '../components/InfoTooltip';
// sections
import { LoginForm } from '../sections/auth/login';
import SERENITY from '../assets/SERENITY.png';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  gap: 10,
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  return (
    <>
      <Helmet>
        <title> Daily Guide | Mood Lift </title>
      </Helmet>

      <StyledRoot>
        <Container maxWidth="sm">
          <StyledContent>
            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={2}>
              <Typography variant="h4" gutterBottom>
                Daily Updates{' '}
                <InfoTooltip
                  width={20}
                  title="Time-of-day content that guests see in their app, split into morning, afternoon and night slots. Each slot holds a file or guide that you upload here. Use this page to upload or replace the material for each slot, then Save so the right update is shown automatically at the matching time of day."
                />
              </Typography>
            </Stack>
            <FormLabel>Morning <InfoTooltip title="Upload the guide or update shown to guests during the morning time slot." /></FormLabel>
            <TextField type="file" />
            <FormLabel>After Noon<InfoTooltip title="Upload the guide or update shown to guests during the afternoon time slot." /></FormLabel>
            <TextField type="file" />
            <FormLabel>Night <InfoTooltip title="Upload the guide or update shown to guests during the evening or night time slot." /></FormLabel>
            <TextField type="file" />
            <Button size="large" variant="contained">
              Save
            </Button>
            {/* <LoginForm /> */}
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
